import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { ProductPipesModule } from '@product/utils';
import { CustomDecimalPipeModule, DistanceFromYouPipe } from '@sdvor/shared/ui';
import { CustomPointOfService } from '@shop/const';
import { ShopWorkingTimeComponent } from '../../shop-working-time';

@Component({
  selector: 'sd-shop-list-item',
  standalone: true,
  imports: [ShopWorkingTimeComponent, DistanceFromYouPipe, CommonModule, ProductPipesModule, CustomDecimalPipeModule],
  templateUrl: './shop-list-item.component.html',
  styleUrls: ['./shop-list-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ShopListItemComponent {
  readonly shop = input.required<CustomPointOfService>();
  readonly activeShopName = input<string>('');
  readonly showAvailability = input<boolean>(false);

  readonly clickShop = output<string>();

  onClickShop(shopName: string): void {
    this.clickShop.emit(shopName);
  }
}
